import Request from "../helpers/request-v2"
import Endpoints from "../config/endpoints"
import _ from 'lodash'

export default class FinancialRequests {

    static getBankBillet(ibbCode, prsCode) {
        return Request
            .getInstance()
            .createGetRequest(`${Endpoints.financial.getInvoiceBankBillet}/${ibbCode}?p=${prsCode}`, {}, {}, true)
            .then(result => {
                return  _.get(result, 'data',  {})
            })
    }

    static generateBankBillet(ibbCode, prsCode) {
        return Request
            .getInstance()
            .createGetRequest(`${Endpoints.financial.generateBankBillet}?prsCode=${prsCode}&ibbCode=${ibbCode}`)
            .then(result => {
                return  _.get(result, 'data',  result)
            })
    }
}




// WEBPACK FOOTER //
// ./src/requests/financial-requests.js